import { RiFolderInfoLine } from 'react-icons/ri';
import styled from 'styled-components';

const NoDataUI = () => {
  return (
    <Wrapper>
      <div>
        <RiFolderInfoLine style={{ fontSize: '70px' }} />
      </div>
      <div
        style={{
          padding: '20px'
        }}
      >
        No Data Available.
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 1rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
export default NoDataUI;
